<template>
    <UModal v-model:open="open" size="sm">
        <slot />
        <template #content="{ close }">
          <UCard>
            <template #header>
              <h3 class="text-lg font-semibold">{{ title }}</h3>
            </template>
              <div class="flex flex-col gap-4">
                  <p class="text-gray-600">
                              {{ description }}
                            </p>

                  <div v-if="askPassword">
                    <UFormField required :label="$t('Password')" name="password">
                        <UInput class="w-full" size="lg" v-model="password" type="password" :placeholder="$t('Enter your password')" />
                    </UFormField>
                  </div>
              </div>
            <template #footer>
              <div class="flex gap-2 justify-end">
                <UButton variant="ghost" @click="close">
                  {{ cancelLabel }}
                </UButton>
                <UButton :disabled="askPassword && !password" color="primary" @click="handleConfirm">
                  {{ confirmLabel }}
                </UButton>
              </div>
            </template>
          </UCard>
        </template>
    </UModal>
</template>
<script setup lang="ts">
const {
  title = "Please confirm",
  description = "Are you sure you want to proceed with this action?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  askPassword = false
} = defineProps<{
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  askPassword?: boolean;
}>()

const emit = defineEmits<{
  (e: 'cancel'): void;
  (e: 'confirm', password?: string): void;
}>()

const open = ref(false)
const password = ref('')

watchEffect(() => {
  if (!open.value) {
    password.value = ''
  }
})

const handleConfirm = () => {
  open.value = false
  if (askPassword) {
    emit('confirm', password.value)
  } else {
    emit('confirm')
  }
}

</script>